import { InjectionToken } from '@angular/core';
import * as Rollbar from 'rollbar';

export const RollbarJS = new InjectionToken<Rollbar>('rollbar');
